export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_06.1456fa10.png";